import streetData from '@/assets/js/pcas-code.json'
export default {
  data() {
    return {
      address1: '',
      address2: '',
      address3: '',
      streetArray: [],
      streetArrayCode: [],
      streetvalue: '',
      streetExplainTxt: '',
      cityCodes: [],
      codeSixArry: []
    }
  },
  methods: {
    getStreetArray(areaValue) {
      if (areaValue === '') {
        return console.log('areaValue为空')
      }
      let streetArr = []
      streetArr = streetData.filter((val) => {
        return val.code === areaValue.substr(0, 2)
      })
      this.address1 = streetArr[0].name

      let streetArr1 = []
      if (streetArr.length !== 0) {
        streetArr1 = streetArr[0].children.filter((val) => {
          return val.code === areaValue.substr(0, 4)
        })
      }
      this.address2 = streetArr1[0].name

      let streetArr2 = []
      if (streetArr1.length !== 0) {
        streetArr2 = streetArr1[0].children.filter((val) => {
          const hasAreaValue = areaValue.substr(0, 6)
          return val.code === hasAreaValue
        })
      }

      this.streetArray = []
      this.streetArrayCode = []
      this.address3 = streetArr2[0].name
      this.streetvalue = this.address1 + this.address2 + this.address3
      streetArr2[0].children.forEach((value) => {
        this.streetArray.push(value)
        this.streetArrayCode.push(value.name)
      })
    },
    // 匹配配送code和显示配送范围说明
    cityCode(cityDistributionScope) {
      this.cityCodes = cityDistributionScope.split(',')
      this.codeSixArry = []
      this.cityCodes.forEach((el) => {
        this.codeSixArry.push(el.substr(0, 6))
      })
      // 显示商家配送范围说明
      if (this.cityCodes.length === 0) {
        console.log('没有配送范围')
        return
      }
      let explainArr = []
      explainArr = streetData.filter((val) => {
        return val.code === this.cityCodes[0].substr(0, 2)
      })
      const addressProvince = explainArr[0].name

      let explainArr1 = []
      if (explainArr.length !== 0) {
        explainArr1 = explainArr[0].children.filter((val) => {
          return val.code === this.cityCodes[0].substr(0, 4)
        })
      }
      const addressCity = explainArr1[0].name

      let explainArr2 = []
      if (explainArr1.length !== 0) {
        explainArr2 = explainArr1[0].children.filter((val) => {
          return val.code === this.cityCodes[0].substr(0, 6)
        })
      }
      const addressCityLevel = explainArr2[0].name
      this.ProvincialMunicipalities =
        addressProvince + addressCity + addressCityLevel
      const streetExplain = []
      explainArr2[0].children.forEach((value) => {
        this.cityCodes.forEach((el) => {
          if (el === value.code) {
            streetExplain.push(value.name)
          }
        })
        if (streetExplain.length > 0) {
          this.streetExplainTxt = streetExplain.join('、')
        }
      })
    }
  }
}
